import React  from 'react';
import Row from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { Link } from "react-router-dom";
export const NoRecords = (props ) => (
    <Row  spacing ={ 2 }   container direction="column" justify="center"  alignItems="center">
        <Row item> No customer added yet!</Row>
        <Row item > <Button   variant="contained" color ="primary" component ={ Link } to ="/add-customer"> Add Customer </Button> </Row>
    </Row>
  );